import React, { useEffect, useState, memo } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';

import { useAuth } from "../../../context/AuthContext";
import { importCryptoWallet, getCryptoWallets } from "../../../store/assetsReducer"

import ImportWallet from './importWallet';
import CreateWallet from './createWallet';

import { CRYPTO_WALLETS, CUSTODIAN_WALLETS, FIAT_WALLETS } from '../../../constants/wallets';

import { WalletType } from "../../../types/rail.types";
import type { AppDispatch, RootState } from '../../../store';
import { CryptoWalletType } from "../../../types/assets.types"

interface WalletData {
  id: string;
  userId: string;
  address: string;
  createdAt: string;
  balances: any;
}

interface WalletItem {
  id: string;
  token:string;
  name:string;
  userId: string;
  address: string;
  createdAt: string;
  balance: string;
  currency:string;
}

interface WalletCardProps {
  wallet: CryptoWalletType;
  isCheckingMainData: boolean;
  createWallet: (wallet: CryptoWalletType) => Promise<boolean>;
  showUsdForm:boolean
}
interface ImportCryptoWalletData {
  info: any,
  currency: string,
  endpoint: string
}
const WalletCard: React.FC<WalletCardProps> = ({
  wallet,
  isCheckingMainData,
  createWallet,
  showUsdForm
}) => {
  const dispatch = useDispatch<AppDispatch>();
  const { user, isFullOnboarding } = useAuth();
  const { data:{mainWallets, cryptoWallets}, status } = useSelector((state: RootState) => state.assets);
  const { data: { cryptoPrices, fiatPrices }, status: rateStatus } = useSelector((state: RootState) => state.setting);
  const { data: ticketStatus } = useSelector((state: RootState) => state.auth.ticketStatus);

  const [walletData, setWalletData] = useState<WalletData>()
  const [openImportWallet, setOpenImportWallet] = useState<boolean>(false);
  const [openCreateWallet, setOpenCreateWallet] = useState<boolean>(false);
  const [isNewlyCreated, setIsNewlyCreated] = useState<boolean>(false);
  const [isProcessing, setIsProcessing] = useState<boolean>(false);
  const [displayBalance, setDisplayBalance] = useState<string>('0')
  // const [currencyUnit, setCurrentUnit] = useState<string>(walletType.shortName)
  const [importData, setImportData] = useState<ImportCryptoWalletData>({
    info: {},
    currency: "",
    endpoint: ""
  })
  useEffect(() => {
    const getWallet = () => {
      let walletDataTmp:WalletData;
      try {
        switch (wallet.token) {
          case "btc":               
            if(cryptoWallets?.data?.bitcoin?.length>0){
              setWalletData(cryptoWallets?.data?.bitcoin[0])
            }
            break;
          case "eth":
            if(cryptoWallets?.data?.ethereum?.length>0){
              setWalletData(cryptoWallets?.data?.ethereum[0])
            }
            break;
          case "usdt_erc20":
          case "usdc_erc20":
            if(cryptoWallets?.data?.ethereum?.length>0){
              const ethWallet = cryptoWallets?.data?.ethereum[0];
              setWalletData(ethWallet)
            } else {
            }
            break;
          case "bnb":
          case "usdt_bep20":
            if(cryptoWallets?.data?.bnb?.length>0){
              const bnbWallet = cryptoWallets?.data?.bnb[0];
              setWalletData(bnbWallet)
            } else {
            }
            break;
          case "trx":
          case "usdt_tron":
           if(cryptoWallets?.data?.tron?.length>0){
              setWalletData(cryptoWallets?.data?.tron[0])
            }
            break;
          case "sol":
          case "usdt_spl":
          case "usdc_spl":
            if(cryptoWallets?.data?.solana?.length>0){
              setWalletData(cryptoWallets?.data?.solana[0])
            }
            break;
        }       
      }
      catch (error) {
      }
    }
    if(status === "succeeded"){
      getWallet();
    }
  }, [status, mainWallets, cryptoWallets])
  // useEffect(() => {
  //   const getDisplayBalance = (walletData: WalletData) => {
  //     // if (walletData) {
  //     //   if (wallet.type === "2") {
  //     //     const walletBalance = walletData.balance;
  //     //     if (wallet.token === 'BTC') {
  //     //       const btcBalance = parseFloat(walletBalance);
  //     //       if (btcBalance >= 0.099) {
  //     //         setDisplayBalance(btcBalance.toLocaleString(undefined, { minimumFractionDigits: 3, maximumFractionDigits: 3 }));
  //     //         // setCurrentUnit('BTC')
  //     //       } else {
  //     //         setDisplayBalance((btcBalance * 1000).toLocaleString(undefined, { minimumFractionDigits: 3, maximumFractionDigits: 3 }));
  //     //         // setCurrentUnit('mBTC')
  //     //       }
  //     //     } else {
  //     //       setDisplayBalance(parseFloat(walletBalance).toLocaleString());
  //     //     }
  //     //   } else {
  //     //     setDisplayBalance(walletData.availableBalance);
  //     //   }
  //     }
  //   }
  //   // getDisplayBalance(walletData)
  // }, [walletData])
  // useEffect(()=>{
  //   if(showUsdForm===false && isNewlyCreated===true){
  //     setIsNewlyCreated(false)
  //   }
  // },[showUsdForm])
  const IconComponent = wallet.icon;
  // const isFiatWallet = FIAT_WALLETS.find(w => w.currency === walletType.currency) !== undefined;
  // const isCustodianWallet = CUSTODIAN_WALLETS.find(w => w.currency === walletType.currency) !== undefined;
  // if ((isFiatWallet || isCustodianWallet) && !isFullOnboarding() && (walletType.type === "0" || walletType.type === "1")) {
  //   return (
  //     <div key={walletType.currency} className="wallet-card">
  //       <IconComponent />
  //       <div className="wallet-card-name">{walletType.name}</div>
  //       <button
  //         className="wallet-create-btn wallet-create-btn-disabled"
  //         disabled={true}
  //         onClick={() => toast.info("You need to complete the full onboarding process to create FIAT wallets.")}
  //       >
  //         Requires Full Onboarding
  //       </button>
  //     </div>
  //   );
  // }

  const handleCreateWallet = async () => {
 
    if (openCreateWallet === false) {   
      setOpenCreateWallet(true)
      return;
    }
    // create(walletType);
  };
  const confirmPermission = () => {
    // if (mainWallets.fiatWallets.data.length < 1 && walletType.type === "0" && walletType.token !== "USD") {
    //   toast.info("Create USA FIAT Wallet First");
    //   setIsNewlyCreated(false);
    //   return false;
    // } else if (mainWallets.fiatWallets.data.length < 1 && walletType.type === "1" && walletType.token !== "USD") {
    //   toast.info("Create USA FIAT Wallet First");
    //   setIsNewlyCreated(false);
    //   return false;
    // }
    //  else {
      return true;
    // }
  }

  const importWallet = async () => {
    try {
      setIsProcessing(true); 
      const result = await dispatch(importCryptoWallet(importData)).unwrap()

        if (result.success) {
          await dispatch(getCryptoWallets(cryptoPrices))
           setOpenImportWallet(false);
          // let cloneCurrency = "";
          // if (importData.currency === "BTC") {
          //   toast.success(`BTC wallet is created successfully!`);
          //   setOpenImportWallet(false);
          //   return;
          // }
          // if (importData.currency === "ETH") {
          //   cloneCurrency = "USDT_ERC20";
          // } else if (importData.currency === "USDT_ERC20") {
          //   cloneCurrency = "ETH";
          // } else if (importData.currency === "TRX") {
          //   cloneCurrency = "USDT_TRON";
          // } else if (importData.currency === "USDT_TRON") {
          //   cloneCurrency = "TRX";
          // } else if (importData.currency === "BNB") {
          //   cloneCurrency = "USDT_BEP20";
          // } else if (importData.currency === "USDT_BEP20") {
          //   cloneCurrency = "BNB";
          // }
          // toast.success(`${importData.currency} and ${cloneCurrency} is imported successfully!`);
        let token = "";
        let clonetoken = "";
        let clonetoken2 = "";

        switch (wallet.token) {
          case "btc":
           token = "BTC";
           break;
          case "eth":
            token = "ETH";
            clonetoken = "USDC ERC20";
            clonetoken2 = "USDT ERC20";
            break;

          case "usdt_erc20":
            token = "USDT ERC20";
            clonetoken = "ETH";
            clonetoken2 = "USDC ERC20";
            break;

          case "usdc_erc20":
            token = "USDC ERC20";
            clonetoken = "ETH";
            clonetoken2 = "USDT ERC20";
            break;

          // Map TRON, BNB, and SOL tokens also to Ethereum-style names
          case "trx":
            token = "TRX";
            clonetoken = "USDT TRC20";
            break;

          case "usdt_tron":
            token = "USDT TRC20";
            clonetoken = "TRX";
            break;

          case "bnb":
            token = "BNB";
            clonetoken = "USDT BEP20";
            break;

          case "usdt_bep20":
            token = "USDT BEP20";
            clonetoken = "BNB";
            break;

          case "sol":
            token = "SOL";
            clonetoken = "USDT SPL";
            clonetoken2 = "USDC SPL";
            break;

          case "usdt_spl":
            token = "USDT SPL";
            clonetoken = "SOL";
            clonetoken2 = "USDC SPL";
            break;

          case "usdc_spl":
            token = "USDC SPL";
            clonetoken = "SOL";
            clonetoken2 = "USDT SPL";
            break;

          default:
            token = wallet.token.toUpperCase();
            break;
        }
       
          toast.success(
            `${token}${ " and "+clonetoken}${clonetoken2 ? " and " + clonetoken2 : ""} wallet is created successfully!`
          );
         
        } else {
          toast.error(result.error || "Failed to import wallet");
          setOpenImportWallet(false);
        }
    
    } catch (error) {
      toast.error("An error occurred while importing the wallet");
      console.error(error);
    } finally {
      setIsProcessing(false); // Re-enable button
    }
  };
  const create = async (walletType:CryptoWalletType) => {
    
    setIsNewlyCreated(true);
   
    if (confirmPermission()) {
    await createWallet(walletType)
    // setIsNewlyCreated(false);
   setOpenCreateWallet(false)
    }
    return;
  }

  // if (walletType.currency === 'USD' && walletType.type === "0" && walletData !== undefined) {
  //   return (
  //     <div className={`wallet-card ${isNewlyCreated ? 'newly-created' : ''}`}>
  //       <IconComponent />
  //       <div className="wallet-card-name">{walletType.name}</div>
  //       <Link
  //         to={`/dashboard/wallets`}
  //         className="wallet-card-balance"
  //       >
  //         {walletData.availableBalance} {currencyUnit}
  //       </Link>
  //     </div>
  //   );
  // }

  // if (ticketStatus && ticketStatus.hasTicket && walletType.currency === "USD") {
  //   const hasRailApplication = mainWallets.fiatWallets.data.some((acc: any) =>
  //     acc.type === 'USD' && (acc.status === 'PENDING' || acc.status === 'INCOMPLETE' || acc.status === 'SUBMITTED')
  //   );
  //   return (
  //     <div className={`wallet-card ${isNewlyCreated ? 'newly-created' : ''}`}>
  //       <IconComponent />
  //       <div className="wallet-card-name">{walletType.name}</div>
  //       <button
  //         className="wallet-create-btn wallet-status-btn"
  //         disabled
  //         title={
  //           !ticketStatus.isCompleted
  //             ? "Your wallet request is being reviewed by our compliance team"
  //             : hasRailApplication
  //               ? "Your wallet is being processed by our USA banking partner"
  //               : "Your wallet application is being prepared"
  //         }
  //       >
  //         {!ticketStatus.isCompleted
  //           ? 'IN REVIEW'
  //           : hasRailApplication
  //             ? 'ONBOARDING'
  //             : 'PROCESSING'}
  //       </button>
  //     </div>
  //   );
  // }

  return (
    <>
      {(walletData !== undefined ) ? (
        <div
          className={`wallet-card ${isNewlyCreated ? 'newly-created' : ''}`}
        >
          <IconComponent />
          <div className="wallet-card-name !font-bold">{wallet.name}</div>
           <Link
              to={`/dashboard/wallets/${wallet.token.toLowerCase()}/${walletData.address }`}
                //  to={`/#}`}
              className="wallet-card-balance"
            >
              {(() => {
                // Mapear el balance correcto según el tipo de token
                let balance = '0';

                // Debug específico para USDT BEP-20
                if (wallet.token === 'usdt_bep20') {
                  if (walletData.balances) {
                  } else {
                  }
                }

                if (walletData.balances) {
                  switch(wallet.token) {
                    case 'btc':
                      balance = walletData.balances.btc || walletData.balances.BTC || '0';
                      break;
                    case 'eth':
                      balance = walletData.balances.eth || walletData.balances.ETH || '0';
                      break;
                    case 'usdt_erc20':
                      balance = walletData.balances.usdt_erc20 || '0';
                      break;
                    case 'usdc_erc20':
                      balance = walletData.balances.usdc_erc20 || '0';
                      break;
                    case 'trx':
                      balance = walletData.balances.trx || walletData.balances.TRX || '0';
                      break;
                    case 'usdt_tron':
                    case 'usdt_trc20':
                      balance = walletData.balances.usdt_trc20 || '0';
                      break;
                    case 'bnb':
                      balance = walletData.balances.bnb || walletData.balances.BNB || '0';
                      break;
                    case 'usdt_bep20':
                      balance = walletData.balances.usdt_bep20 || '0';
                      break;
                    case 'sol':
                      balance = walletData.balances.sol || walletData.balances.SOL || '0';
                      break;
                    case 'usdt_spl':
                      balance = walletData.balances.usdt_spl || '0';
                      break;
                    case 'usdc_spl':
                      balance = walletData.balances.usdc_spl || '0';
                      break;
                    default:
                      balance = walletData.balances[wallet.currency.toLowerCase()] || '0';
                  }
                }

                // Limit decimals to 5 for crypto wallets in the grid view
                const numBalance = parseFloat(balance);
                const formattedBalance = !isNaN(numBalance) && numBalance > 0
                  ? numBalance.toFixed(Math.min(5, (balance.split('.')[1] || '').length))
                  : '0';

                return `${formattedBalance} ${wallet.currency}`;
              })()}
            </Link>
          {/* {(walletType.type == "2") ? (
            <Link
              to={`/dashboard/wallets/${walletType.currency.toLowerCase()}/${walletType.type === "2" ? walletData.address : walletData.id
                }`}
              className="wallet-card-balance"
            >
              {displayBalance} {currencyUnit}
            </Link>
          ) : (
            <Link
              to={`/dashboard/wallets`}
              className="wallet-card-balance"
            >
              {displayBalance} {currencyUnit}
            </Link>
          )} */}
        </div>
      ) : (
        <>
          <div
            className={`wallet-card ${isNewlyCreated ? 'newly-created' : ''}`}
          >
            <IconComponent />
            <div className="wallet-card-name !font-bold">{wallet.name}</div>

            {isNewlyCreated ? (
              <div className="wallet-card-creating">Wallet creating...</div>
            ) : isProcessing ? (
              <button className="wallet-create-btn wallet-create-btn-disabled" disabled={true}>
                Processing
              </button>
            ) : (
              <button
                className={`wallet-create-btn ${isProcessing ? 'wallet-create-btn-disabled' : ''}`}
                onClick={handleCreateWallet}
                disabled={isProcessing}
              >
                {isProcessing || (wallet.token === 'USD' && isCheckingMainData)
                  ? 'Processing...'
                  : 'Create Wallet'}
              </button>
            )}
          </div>
          {(openCreateWallet) && (
            <CreateWallet isOpen={openCreateWallet} setOpenCreateWallet={setOpenCreateWallet} setOpenImportWallet={setOpenImportWallet} createWallet={create} wallet={wallet} confirmPermission={confirmPermission} isNewlyCreated={isNewlyCreated} />
          )}
          {openImportWallet && (
            <ImportWallet token={wallet.token} isOpen={openImportWallet} setOpenImportWallet={setOpenImportWallet} addWallet={importWallet} setImportData={setImportData} />
          )}
        </>
      )}
    </>
  );
};

export default memo(WalletCard);